import React from 'react'
import TextComponent from './TextComponent'
import { VideojuegosModel } from './VideojuegosModel'

export default function VideojuegosSection({isMobile}) {
  return (
    <group>
      <TextComponent weight="light" fs={0.5} position={[0, 0.5, 0]} rotation={[0, 0, 0]} txt="Videojuegos" id="videojuegos" is3D={false} />
      <VideojuegosModel isMobile={isMobile} scale={0.5} rotation={[0,-Math.PI /2,0]} position={[0,-1.5,0]} />
    </group>
  )
}
